"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportcsv = exportcsv;
exports.downloadLink = exports.exportMetricsExcelFile = exports.downloadTxtFile = void 0;

var _js2excel = require("js2excel");

var _index = require("./index"); //Library to export json to xlsx
//https://www.npmjs.com/package/js2excel
// Source: https://gist.github.com/dreamyguy/6b4ab77d2f118adb8a63c4a03fba349d


function exportcsv(data, filename, mime) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var blob = new Blob([data], {
    type: mime || 'application/octet-stream'
  });

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE doesn't allow using a blob object directly as link href.
    // Workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
    return;
  } // Other browsers
  // Create a link pointing to the ObjectURL containing the blob


  var blobURL = window.URL.createObjectURL(blob);
  var tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename); // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(blobURL);
  }, 100);
}

var downloadTxtFile = function downloadTxtFile(fileName, text) {
  var element = document.createElement("a");
  var file = new Blob([text], {
    type: 'text/plain'
  });
  element.href = URL.createObjectURL(file);
  element.download = fileName;
  document.body.appendChild(element); // Required for this to work in FireFox

  element.click();
  document.body.removeChild(element);
};

exports.downloadTxtFile = downloadTxtFile;

var exportMetricsExcelFile = function exportMetricsExcelFile(fileName, data, excludedColumns) {
  //temporary object that will hold each rows data till its appended to resultArray then cleared
  var tempObj = {}; //array that will be used to hold each row and eventually be printed to an excel file

  var resultArray = []; //this forEach will loop through the data and filter each row of all excluded columns then append that row to the resultArray

  data.forEach(function (row) {
    //this line will take the 'total' column from the last position and move it to the first position
    if (Object.keys(row)[Object.keys(row).length - 1] === 'total') tempObj[""] = row[Object.keys(row)[Object.keys(row).length - 1]];

    for (var column = 0; column <= Object.keys(row).length - 2; column += 1) {
      if (!excludedColumns.includes(Object.keys(row)[column])) {
        tempObj[Object.keys(row)[column]] = row[Object.keys(row)[column]];
      }
    }

    resultArray.push(tempObj);
    tempObj = {};
  }); //this is the method imported from js2xcel that takes in data, filename, and date created

  (0, _js2excel.json2excel)({
    data: resultArray,
    name: fileName,
    formateDate: new Date()
  });
};

exports.exportMetricsExcelFile = exportMetricsExcelFile;

var downloadLink = function downloadLink(link) {
  var areWeByPassingBrowserAlert = window.onbeforeunload && window.onbeforeunload();
  if (areWeByPassingBrowserAlert) (0, _index.browserAlertOff)();
  var hiddenElement = document.createElement('a');
  hiddenElement.href = link;
  hiddenElement.click();
  if (areWeByPassingBrowserAlert) (0, _index.browserAlertOn)();
};

exports.downloadLink = downloadLink;